export default __webpack_public_path__ + "static/media/entenda.41357e92.webp";